import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReprogrammingService } from '../../../features/offers/offers-euro/reprogramming.service';
import { JwtService } from '../../services/jwt/jwt.service';
import { LoginService } from 'src/app/features/login/login.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-payment-address-popup',
    templateUrl: './payment-address-popup.component.html',
    styleUrls: ['./payment-address-popup.component.sass'],
    standalone: false
})

export class PaymentAddressPopupComponent {

  userInfoPop = true;
  hasError = false;
  profileInfo: any;
  deliveryCountryId: any;
  deliveryDiallingCode = '';
  errorMessage: any;
  deliveryCountryName: any;
  initialFormData: any;
  isLoader = false;

  constructor(private dialogRef: MatDialogRef<PaymentAddressPopupComponent>, public router: Router,
              private reprogramService: ReprogrammingService, private jwtService: JwtService, private loginService: LoginService,
              @Inject(MAT_DIALOG_DATA) public data: { userData: any, countryList: any, filteredCountryList: any }) {
    this.profileInfo = { ...this.data.userData };
    this.initialFormData = { ...this.data.userData };
    this.deliveryCountryId = this.profileInfo.deliveryCountryId;
    this.deliveryCountryName = this.data.countryList[this.deliveryCountryId - 1].countryName;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  openEditForm(): void {
    this.userInfoPop = false;
  }

  backToHome(): void {
    this.userInfoPop = true;
    this.profileInfo = { ...this.initialFormData };
    this.deliveryCountryId = this.profileInfo.deliveryCountryId;
    this.deliveryCountryName = this.data.countryList[this.deliveryCountryId - 1].countryName;
  }

  confirmPay(): void {
    this.dialogRef.close(true);
  }

  cancelPay(): void {
    this.dialogRef.close(false);
  }

  countryChange(val: any) {
    const selected = this.data.filteredCountryList.find((item: any) => item.countryId === val);
    if(selected) {
      this.deliveryCountryId = val;
      this.profileInfo.deliveryDiallingCode = "+" + selected.dialingCode;
      this.profileInfo.deliveryCountryName = selected.countryName;
    }
  }

  isFormChanged(): boolean {
    return JSON.stringify(this.profileInfo) !== JSON.stringify(this.initialFormData);
  }

  submitEditProfile() {
    this.hasError = false;
    this.profileInfo.deliveryCountryId = this.deliveryCountryId;
    let updatedDeliveryMobileNumber = this.profileInfo.deliveryMobileNumber;
    this.profileInfo.deliveryMobileNumber = this.profileInfo.deliveryDiallingCode + '-' + this.profileInfo.deliveryMobileNumber;
    let profileData: string = this.jwtService.encode(this.profileInfo, "secret");
    this.isLoader = true;
    this.reprogramService.updateUserDetails(profileData).subscribe((response: any) => {
      this.isLoader = false;
      if(response.error) {
        this.hasError = response.error;
        this.errorMessage = response.errorMessage;
      } else {
        this.hasError = response.error;
        this.errorMessage = '';
        this.profileInfo.deliveryMobileNumber = updatedDeliveryMobileNumber;
        if(response.accessIdentifier === 'INDADMIN') {
          this.loginService.setGigyaResponse(this.profileInfo);
        }
        // Sync initialFormData so profileInfo isn't overwritten on backToHome()
        this.initialFormData = { ...this.profileInfo };
        // Update country name in case it was changed
        const selectedCountry = this.data.filteredCountryList.find((item: any) => item.countryId === this.deliveryCountryId);
        if(selectedCountry) {
          this.deliveryCountryName = selectedCountry.countryName;
        }
        this.userInfoPop = true;
      }
    });
  }
  
}